import React, {Component} from 'react';
import {Grid, Col, Row, Button, FormControl} from 'react-bootstrap';

import Datetime from 'react-datetime'
import moment from 'moment'
import Select   from 'react-select'
 import {ADD_SELECTED_PRODUCTS, CLEAR_SELECTED_PRODUCTS} from 'actions/actionTypes';
import {prepareSelectOptionsList,} from 'util/Utils';
import config from  '../../../config';



 var palletStatusOptions = [
    {value: 'Incoming', label: 'Incoming'},
    {value: 'In Progress', label: 'In Progress'},
    {value: 'Checked', label: 'Checked'}
];
var statusOptions = [
    {value: 'Active', label: 'Active'},
    {value: 'Inactive', label: 'Inactive'}
];
export default class PartnerProductSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);

        var selectedMarkets = _.isUndefined(this.props.location.query.Markets) ? [] : _.map(this.props.location.query.Markets.split(','), function (item) {
            var location = _.find(config.warehouseData, function (o) {
                return o.MarketName == item
            });
            if (location) {
                return {'value': item, 'label': location.MarketName}
            }
        })
           this.state = {
             filterOptions: {
                 perPage: _.isUndefined(this.props.location.query.perPage) ?  30 : this.props.location.query.perPage,
                 SellerID: _.isUndefined(this.props.location.query.SellerID) ? 'all' : this.props.location.query.SellerID,
                 'fromCreateTimeDisplay': _.isUndefined(this.props.location.query.from) ? '' : moment(this.props.location.query.from),
                'toCreateTimeDisplay': _.isUndefined(this.props.location.query.to) ? '' : moment(this.props.location.query.to),
                 'fromSoldTimeDisplay': _.isUndefined(this.props.location.query.fromSoldAt) ? '' : moment(this.props.location.query.fromSoldAt),
                 'toSoldTimeDisplay': _.isUndefined(this.props.location.query.toSoldAt) ? '' : moment(this.props.location.query.toSoldAt),
                 maxPrice: _.isUndefined(this.props.location.query.maxPrice) ? '' : this.props.location.query.maxPrice,
                minPrice: _.isUndefined(this.props.location.query.minPrice) ? '' : this.props.location.query.minPrice,
                 searchText: _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,

                disposition:  _.isUndefined(this.props.location.query.disposition) ?  [] : _.isArray(this.props.location.query.disposition) ? _.map(this.props.location.query.disposition, function (value) {
                    return _.find(config.dispositionOptions, {value:value})
                }) : [_.find(config.dispositionOptions, {value:this.props.location.query.disposition})],

                Statuses:  _.isUndefined(this.props.location.query.Statuses) ?  [] : _.isArray(this.props.location.query.Statuses) ? _.map(this.props.location.query.Statuses, function (value) {
                    return _.find(statusOptions, {value:value})
                }) : [_.find(statusOptions, {value:this.props.location.query.Statuses})],
                 Markets: selectedMarkets,
                 Deleted:_.isUndefined(this.props.location.query.Deleted) ? null : this.props.location.query.Deleted,
                fromQuantity: _.isUndefined(this.props.location.query.fromQuantity) ? '' : this.props.location.query.fromQuantity,
                 toQuantity: _.isUndefined(this.props.location.query.toQuantity) ? '' : this.props.location.query.toQuantity,
                  recordIDs:  _.get(this.props.location.query, 'recordIDs', [])
            }
        };
        this.allSellersOptionsList = prepareSelectOptionsList(this.props.allSellersList.data, {
            label: 'DisplayName',
            value: '_id'
        })
         this.allCreatedByOptionsList = [ ]

        this.onCreateTimeChange = this.onCreateTimeChange.bind(this);
        this.allSellersOptionsList.unshift({label: 'All', value: 'all'});
    };

    componentWillReceiveProps(nextProps) {


        if (_.size(nextProps.allSellersList.data) !== _.size(this.props.allSellersList.data)) {
            this.allSellersOptionsList = prepareSelectOptionsList(nextProps.allSellersList.data, {
                label: 'DisplayName',
                value: '_id'
            })

        }
    }

    onChangePerPageNumber(option) {
        this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}}, function () {
            this.props.search();
        });
    }

    getSearchParams(filtersChanged = {}) {
         let filterOptions = {...this.state.filterOptions, ...filtersChanged};
        let queryParams = {
          useAnalyticDatabase:true
        };
        if (filterOptions.perPage == 'all') {
            queryParams.all = true
        } else {
            queryParams.perPage = filterOptions.perPage;
        }





        if (filterOptions.SellerID !== 'all') {
            queryParams.SellerID = filterOptions.SellerID;
        }





        if (filterOptions.fromCreateTimeDisplay !== '') {
            queryParams.from = filterOptions.fromCreateTimeDisplay.toISOString()
        }
        if (filterOptions.toCreateTimeDisplay !== '') {
            queryParams.to = filterOptions.toCreateTimeDisplay.toISOString()
        }
        if (filterOptions.maxPrice !== '') {
            queryParams.maxPrice = filterOptions.maxPrice;
        }

        if (filterOptions.minPrice !== '') {
            queryParams.minPrice = filterOptions.minPrice;
        }

        if (filterOptions.fromQuantity !== '') {
            queryParams.fromQuantity = filterOptions.fromQuantity;
        }
        if (filterOptions.toQuantity !== '') {
            queryParams.toQuantity = filterOptions.toQuantity;
        }
        if (filterOptions.fromSoldTimeDisplay !== '') {
            queryParams.fromSoldAt = filterOptions.fromSoldTimeDisplay.toISOString()
        }
        if (filterOptions.toSoldTimeDisplay !== '') {
            queryParams.toSoldAt = filterOptions.toSoldTimeDisplay.toISOString()
        }
        if (filterOptions.searchText !== '') {
            queryParams.searchText = filterOptions.searchText;
        }



        if ( _.size(filterOptions.disposition) ) {
            queryParams.disposition = _.map(filterOptions.disposition, 'value')
        }



         return {queryParams}

    }

    onSelectAllProductsChange() {
        var self = this;
        if (!this.props.selectAllProducts) {

            this.props.search({include: ['_id'], all: true}).then(response => {
                this.props.toggleAllProductsSelection(true)
                console.log('productIDs', response);

                self.props.dispatchAction(response.data.data, ADD_SELECTED_PRODUCTS)
            });
        } else {
            this.props.toggleAllProductsSelection(false);

            this.props.dispatchAction({}, CLEAR_SELECTED_PRODUCTS)
        }
    }





    onSearchTextChange(event) {
        var updateOptions = {...this.state.filterOptions, searchText: event.target.value};
        this.setState({'filterOptions': updateOptions});
    }





    onSellerChange(option) {

        var updateOptions = {...this.state.filterOptions, SellerID:  option ? option.value:null};
        this.setState({'filterOptions': updateOptions}, function () {
            this.props.search();
        });
    }


    onCreateTimeChange(option, createTimeOptionName) {
        var isSameDate =  moment(this.state.filterOptions[createTimeOptionName]).isSame(option, 'day')
        var updateOptions = {...this.state.filterOptions, [createTimeOptionName]: option};
        this.setState({'filterOptions': updateOptions}, function () {
            if (!isSameDate) {/* do not trigger search when time is updated*/
                this.props.search();
            }
        });
    }



    onPriceChange(event, priceOptionName) {
         this.setState({'filterOptions': {...this.state.filterOptions, [priceOptionName]: event.target.value}});
    }



    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.search();
        }
    }

    render() {
        var self = this;


         console.log('this state search', this.state  );
        return (
            <div className="product-search-block">
                <Row className="show-grid">

                    <Col md={2} sm={2}  xs={3}  className="top10">
                    <Button className="btn btn-primary" disabled={this.props.pending} onClick={this.onSelectAllProductsChange.bind(this)}>
                        {this.props.selectAllProducts ? 'Clear selection' : 'Select all' }
                    </Button>
                </Col>
                    <Col  md={1} sm={2}  xs={3} className="top10">
                        <Select
                            tabIndex="0"
                            //  onBlur={ collapse }
                            //optionRenderer={renderOption}
                            //valueRenderer={renderValue}
                            placeholder="Per Page"
                            clearable={false}
                            options={config.perPageSelectOptions}
                            onChange={this.onChangePerPageNumber.bind(this)}
                            value={self.state.filterOptions.perPage}
                        />
                    </Col>
                </Row>

                <Row  >
                    <Col xs={8} md={3} sm={3}className=" top10 pright0">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.searchText}
                                     onKeyPress={ (e)=>{
                                         if (e.key === 'Enter') {
                                             this.props.search();
                                         }}
                                     }
                                     onChange={this.onSearchTextChange.bind(this)} ref="searchText"
                                     placeholder="Search"/>
                    </Col>
                </Row>
                <Row>
                    <Col xs={8}     md={6} sm={6} className="top10 pright0">

                        <Col xs={6} className="pleft0  pright5">
                            <FormControl type="text"
                                         defaultValue={this.state.filterOptions.fromQuantity}
                                         onKeyPress={this._handleKeyPress.bind(this)}
                                         onChange={(e) => {
                                             this.setState({'filterOptions': {...this.state.filterOptions, ['fromQuantity']: e.target.value}});
                                         }  }
                                         placeholder="Min. Qty"/>
                        </Col>
                        <Col xs={6} className="pleft7 pright0">
                            <FormControl type="text"
                                         defaultValue={this.state.filterOptions.toQuantity}
                                         onKeyPress={this._handleKeyPress.bind(this)}
                                         onChange={(e) => {
                                             this.setState({'filterOptions': {...this.state.filterOptions, ['toQuantity']: e.target.value}});
                                         }  }
                                         placeholder="Max. Qty"/>
                        </Col>
                    </Col>
                    <Col xs={8}     md={6} sm={6} className="top10 pright0">
                        <Col xs={6} className="pleft0  pright5">
                            <Datetime dateFormat={'MM-DD-YYYY'}  timeFormat={false}
                                      onChange={(value) => {
                                          this.setState({'filterOptions': {...this.state.filterOptions, ['fromSoldTimeDisplay']: value}}, function() {
                                              self.props.search()
                                          });
                                      }  }
                                      value={this.state.filterOptions.fromSoldTimeDisplay}
                                      inputProps={{placeholder: 'From Sold Time'}}/>
                        </Col>
                        <Col xs={6} className="pleft7 pright0">
                            <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                      onChange={(value) => {
                                          this.setState({'filterOptions': {...this.state.filterOptions, ['toSoldTimeDisplay']: value}}, function() {
                                              self.props.search()
                                          });
                                      }  }
                                      value={this.state.filterOptions.toSoldTimeDisplay}
                                      inputProps={{placeholder: 'To Sold Time'}}/>
                        </Col>
                    </Col>


                </Row>
                <Row>

                    <Col xs={8}     md={6} sm={6} className="top10 pright0">
                        <Col xs={6} className="pleft0  pright5">
                            <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                      onChange={(value) => this.onCreateTimeChange(value, 'fromCreateTimeDisplay')}
                                      value={this.state.filterOptions.fromCreateTimeDisplay}
                                      inputProps={{placeholder: 'From'}}/>
                        </Col>
                        <Col xs={6} className="pleft7 pright0">
                            <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                      onChange={(value) => this.onCreateTimeChange(value, 'toCreateTimeDisplay')}
                                      value={this.state.filterOptions.toCreateTimeDisplay}
                                      inputProps={{placeholder: 'To'}}/>
                        </Col>
                    </Col>
                    <Col xs={8}     md={6} sm={6} className="top10 pright0">

                        <Col xs={6} className="pleft0  pright5">
                            <FormControl type="text"
                                         defaultValue={this.state.filterOptions.minPrice}
                                         onKeyPress={this._handleKeyPress.bind(this)}
                                         onChange={(e) => this.onPriceChange(e, 'minPrice')} ref="searchminPrice"
                                         placeholder="Min. price"/>
                        </Col>
                        <Col xs={6} className="pleft7 pright0">
                            <FormControl type="text"
                                         defaultValue={this.state.filterOptions.maxPrice}
                                         onKeyPress={this._handleKeyPress.bind(this)}
                                         onChange={(e) => this.onPriceChange(e, 'maxPrice')} ref="searchmaxPrice"
                                         placeholder="Max. price"/>
                        </Col>
                    </Col>
                </Row>
            <Row>
                <Col xs={8} md={3} sm={3} className=" top10 pright0">
                        <Select
                            tabIndex="0"
                            //  onBlur={ collapse }
                            //optionRenderer={renderOption}
                            //valueRenderer={renderValue}
                            placeholder="Seller"
                            clearable={true}
                            options={this.allSellersOptionsList}
                            onChange={this.onSellerChange.bind(this)}
                            //  filterOptions={filterOptions}
                            value={this.state.filterOptions.SellerID}
                        />
                    </Col>


                <Col xs={8} md={3} sm={3} className=" top10 pright0">

                    <Select
                        tabIndex="0"
                        placeholder="Disposition"
                        clearable={false}
                        multi
                        options={config.dispositionOptions}
                        onChange={(selectedOptions) => {
                            this.setState({
                                'filterOptions': {
                                    ...this.state.filterOptions,
                                    disposition: selectedOptions
                                }
                            }, function () {
                                self.props.search({page: 1})
                            });
                        }}
                        value={self.state.filterOptions.disposition}
                    />
                </Col>
                </Row>
                <Row>


                    <Col md={3} xs={6} className="pull-right top10">
                        <button className="pull-right btn btn-primary"
                                disabled={this.props.pending}
                                onClick={(event) => self.props.search({page: 1})}
                                type="button">
                            Search
                        </button>
                    </Col>
                </Row>
            </div>
        );

    }
}



